import { Component, Input, Output, EventEmitter, inject, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { HeaderFacadeService } from '../services/header-facade.service';

@Component({
  selector: 'app-notifications-drawer',
  standalone: true,
  imports: [CommonModule, MatRippleModule],
  templateUrl: './notifications-drawer.component.html',
  styleUrls: ['./notifications-drawer.component.css']
})
export class NotificationsDrawerComponent implements OnChanges {
  @Input() isOpen = false;
  @Output() closeDrawer = new EventEmitter<void>();

  protected readonly headerFacade = inject(HeaderFacadeService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      this.loadNotifications();
    }
  }

  loadNotifications(): void {
    this.headerFacade.loadNotifications().subscribe();
  }

  onClose(): void {
    this.closeDrawer.emit();
  }
}
